export default __webpack_public_path__ + "static/media/PROMETHEUS.8c69073c.jpg";